import { z } from 'zod'
import { addressSchema } from '@/shared/schemas/addressSchema'

export const LICENSE_TYPES = ['MONTHLY', 'ANNUAL'] as const
export type LicenseTypeValue = (typeof LICENSE_TYPES)[number]

export const createOrganizationSchema = z.object({
  legalName: z.string().trim().min(3, 'Mínimo 3 caracteres').max(80, 'Máximo 80 caracteres'),
  propietaryName: z
    .string()
    .trim()
    .min(2, 'Indica el nombre del propietario')
    .max(160),
  description: z
    .string()
    .trim()
    .max(500, 'Máximo 500 caracteres')
    .optional()
    .or(z.literal('')),
  logo: z.string().trim().max(500).optional().or(z.literal('')),
  licenseType: z.enum(LICENSE_TYPES, {
    message: 'Selecciona el tipo de facturación',
  }),
  plannedDayToPay: z
    .number({ message: 'Indica un día válido' })
    .int()
    .min(1, 'Mínimo 1')
    .max(28, 'Máximo 28')
    .optional()
    .nullable(),
  categoryIds: z.array(z.number().int().positive()).optional(),
  packageServiceIds: z
    .array(z.number().int().positive())
    .min(1, 'Selecciona al menos un servicio'),
  address: addressSchema,
})

export type CreateOrganizationFormValues = z.infer<typeof createOrganizationSchema>

export const GENERAL_INFO_FIELDS = [
  'legalName',
  'propietaryName',
  'description',
  'logo',
  'licenseType',
  'categoryIds',
] as const satisfies ReadonlyArray<keyof CreateOrganizationFormValues>

export const ADDRESS_FIELDS = ['address'] as const satisfies ReadonlyArray<
  keyof CreateOrganizationFormValues
>
